/**
 * @module actions/chains
 */
import axios from 'axios'
import { API_URL } from '../constants'

/**
 * @description Get all chains from api
 * @return {Promise} Axios promise
 */
export function getChains () {
  let url = API_URL + '/Chain/Get'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get chain stats from api
 * @return {Promise} Axios promise
 */
export function getChainStats (data) {
  let url = API_URL + '/Permissions/PermissionsHistory'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get chain by id from api
 * @return {Promise} Axios promise
 */
export function getChain (ChainId) {
  let url = API_URL + '/Chain/Get/' + ChainId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get update / insert chain to api
 * @return {Promise} Axios promise
 */
export function createSaveChain (data) {
  let url = API_URL + '/Chain/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function getAdminChains (ChainId) {
  let url = API_URL + '/ChainAdmin/' + ChainId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get chain by id from api
 * @return {Promise} Axios promise
 */
export function getAdminChain (UserId) {
  let url = API_URL + '/ChainAdmin/Get/' + UserId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get update / insert chain to api
 * @return {Promise} Axios promise
 */
export function createSaveAdminChain (data) {
  let url = API_URL + '/ChainAdmin/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get all forsilist chains from api
 * @return {Promise} Axios promise
 */
export function getForsiList () {
  let url = API_URL + '/Chain/ForsiList'
  return dispatch => {
    return axios.get(url)
  }
}

export function updateForsiList (id, active) {
  let url = API_URL + '/Chain/ForsiList/Post'
  return dispatch => {
    return axios.post(url, {
      ShopId: id,
      Active: active
    })
  }
}

export function getCurrencies () {
  let url = API_URL + '/Currency/'
  return dispatch => {
    return axios.get(url)
  }
}

export function getHttpIntegrationLogs (type) {
  let url = API_URL + `/Chain/IntegrationLogs/http/${type}`
  return dispatch => {
    return axios.get(url)
  }
}

export function getDBSLogs () {
  let url = API_URL + '/Chain/IntegrationLogs/dbs'
  return dispatch => {
    return axios.get(url)
  }
}

export function getForsiTokenLogs () {
  let url = API_URL + '/Chain/IntegrationLogs/forsiToken'
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/chains.js